import type { RouteObject } from 'react-router';
import { RequirePermission } from '@/app/require-permission';
import { CampaignsPage } from './campaigns-page';
import { CustomerDetailPage } from './customer-detail-page';
import { CustomersPage } from './customers-page';
import { LoyaltyPage } from './loyalty-page';

export const appRoutes: RouteObject[] = [
  {
    path: 'clientes',
    element: (
      <RequirePermission anyOf={['customers.read']}>
        <CustomersPage />
      </RequirePermission>
    ),
  },
  {
    path: 'clientes/:id',
    element: (
      <RequirePermission anyOf={['customers.read']}>
        <CustomerDetailPage />
      </RequirePermission>
    ),
  },
  {
    path: 'fidelidade',
    element: (
      <RequirePermission anyOf={['loyalty.manage']}>
        <LoyaltyPage />
      </RequirePermission>
    ),
  },
  {
    path: 'campanhas',
    element: (
      <RequirePermission anyOf={['campaigns.manage']}>
        <CampaignsPage />
      </RequirePermission>
    ),
  },
];
